import $ from 'jquery';
import axios from "axios";
import {
    quizShareVkBtnHandler,
    quizShareTelegramBtnHandler,
    shareTelegramBtnHandler,
    shareVkBtnHandler,
    shareWhatsappBtnHandler
} from "../common/dataLayer/data-layer-metrica-handlers";
import {insertSharingButtons} from "./insert-sharing-buttons";

export const handlerShareBtn = () => {
    insertSharingButtons();

    $(document).on('click', '.sharing-btn', function () {
        const button = $(this);
        const elementData =button.data();

        axios.post(
            elementData['url'],
            {
                entityId: elementData['entityId'],
                entityType: elementData['entityType'],
                type: elementData['type']
            }
        );

        return true;
    });

    $(document).on('click', '.vkSharingBtn', () => {
        shareVkBtnHandler();

        if ($(this).parents('.quiz-share-btn-container').length) {
            quizShareVkBtnHandler();
        }
    });

    $(document).on('click', '.telegramSharingBtn', () => {
        shareTelegramBtnHandler();

        if ($(this).parents('.quiz-share-btn-container').length) {
            quizShareTelegramBtnHandler();
        }
    });

    $(document).on('click', '.whatsappSharingBtn', () => {
        shareWhatsappBtnHandler();
    });
};
